import { TRANSLATIONS_FR_SHELL_AND_COMMON } from "./translations.fr.shell-and-common";
import { TRANSLATIONS_FR_SETTINGS_CORE } from "./translations.fr.settings-core";
import { TRANSLATIONS_FR_SETTINGS_GOOGLE } from "./translations.fr.settings-google";
import { TRANSLATIONS_FR_SETTINGS_MICROSOFT } from "./translations.fr.settings-microsoft";
import { TRANSLATIONS_FR_DOCUMENTS_AND_DRIVE } from "./translations.fr.documents-and-drive";
import { TRANSLATIONS_FR_CHAT_TASKS_AND_PROFILE } from "./translations.fr.chat-tasks-and-profile";
import { TRANSLATIONS_FR_DASHBOARD_AND_KNOWLEDGE } from "./translations.fr.dashboard-and-knowledge";
import { TRANSLATIONS_FR_PLANS_AND_ADMIN } from "./translations.fr.plans-and-admin";
import { TRANSLATIONS_FR_ONBOARDING } from "./translations.fr.onboarding";
import { TRANSLATIONS_FR_GENERATION } from "./translations.fr.generation";
import { TRANSLATIONS_FR_HOME_ACTIONS_AND_OVERVIEW } from "./translations.fr.home-actions-and-overview";
import { TRANSLATIONS_FR_HOME_DECISION_DETAIL } from "./translations.fr.home-decision-detail";
import { TRANSLATIONS_FR_HOME_QUEUE_AND_ACTIVITY } from "./translations.fr.home-queue-and-activity";
import { TRANSLATIONS_FR_HOME_PULSE_AND_CALENDAR } from "./translations.fr.home-pulse-and-calendar";
import { TRANSLATIONS_FR_HOME_QUALITY_AND_ALERTS } from "./translations.fr.home-quality-and-alerts";

export const TRANSLATIONS_FR = {
  ...TRANSLATIONS_FR_SHELL_AND_COMMON,
  ...TRANSLATIONS_FR_SETTINGS_CORE,
  ...TRANSLATIONS_FR_SETTINGS_GOOGLE,
  ...TRANSLATIONS_FR_SETTINGS_MICROSOFT,
  ...TRANSLATIONS_FR_DOCUMENTS_AND_DRIVE,
  ...TRANSLATIONS_FR_CHAT_TASKS_AND_PROFILE,
  ...TRANSLATIONS_FR_DASHBOARD_AND_KNOWLEDGE,
  ...TRANSLATIONS_FR_PLANS_AND_ADMIN,
  ...TRANSLATIONS_FR_ONBOARDING,
  ...TRANSLATIONS_FR_GENERATION,
  ...TRANSLATIONS_FR_HOME_ACTIONS_AND_OVERVIEW,
  ...TRANSLATIONS_FR_HOME_DECISION_DETAIL,
  ...TRANSLATIONS_FR_HOME_QUEUE_AND_ACTIVITY,
  ...TRANSLATIONS_FR_HOME_PULSE_AND_CALENDAR,
  ...TRANSLATIONS_FR_HOME_QUALITY_AND_ALERTS,
};
